import React, { useState } from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import { WrappedInputText } from './WrappedInputText.component';

export const CollapsibleInput = ({
	className,
	label,
	children,
	dataqa,
	...rest
}) => {
	const [collapsed, setCollapsed] = useState(true);

	const toggleDropdownClick = () => {
		// Add Segment event tracking for when user expands/collapses an input
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'button',
				field_name_dataqa: `${dataqa}-collapse-button`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		setCollapsed(!collapsed);
	};

	return (
		<div className={`common-ui-collapsible-input ${className || ''}`}>
			<div className="collapsible-input-wrapper">
				<a
					className="collapsible-input-label"
					role="button"
					tabIndex={0}
					onClick={toggleDropdownClick}
					{...{ dataqa: `${dataqa}-collapse-button` }}
				>
					{label}
					<span
						className={`pi ${collapsed ? 'pi-angle-right' : 'pi-angle-down'}`}
					/>
				</a>
				<WrappedInputText dataqa={dataqa} {...rest} />
			</div>
			<div
				className={`collapsible-hidden-wrapper ${collapsed ? 'collapsed' : 'expanded'}`}
			>
				{collapsed ? null : children}
			</div>
		</div>
	);
};
